import { Box, Text, tokens } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const PriceInfo = ({ price }: { price: string }) => {
  return (
    <Box
      component="span"
      style={{
        font: tokens.fonts.sizes[700],
        fontWeight: tokens.fonts.weights.semibold,
        color: tokens.colors.grey1000,
      }}
    >
      {price}
    </Box>
  )
}

type Props = {
  price: string
  isYearly?: boolean
}

export const FormatPrice = ({ price, isYearly = false }: Props) => {
  return (
    <Box flexDirection="row" gap="s4" alignItems="flexEnd">
      <PriceInfo price={price} />
      <Text size="400" color="grey1000">
        /
      </Text>
      <Text size="300" color="grey1000">
        {isYearly ? i18n.t('common.year') : i18n.t('common.month')}*
      </Text>
    </Box>
  )
}
